<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <!-- セッション切れメッセージ -->
      <div v-if="isSessionExpired" class="mx-4 mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
        <p class="text-sm text-yellow-800 text-center">
          セッションの有効期限が切れました。再度ログインしてください。
        </p>
      </div>

      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        ログイン
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        または
        <router-link to="/register" class="font-medium text-blue-600 hover:text-blue-500">
          新規登録する
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="handleLogin" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              メールアドレス
            </label>
            <div class="mt-1">
              <input
                v-model="form.email"
                id="email"
                name="email"
                type="email"
                autocomplete="email"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              パスワード
            </label>
            <div class="mt-1">
              <input
                v-model="form.password"
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div v-if="errorMessage" class="text-red-600 text-sm">
            {{ errorMessage }}
          </div>

          <div>
            <button
              type="submit"
              :disabled="isLoading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
            >
              {{ isLoading ? 'ログイン中...' : 'ログイン' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const authStore = useAuthStore()
    
    const form = ref({
      email: '',
      password: ''
    })
    
    const errorMessage = ref('')
    const isLoading = ref(false)
    const isSessionExpired = ref(route.query.expired === '1')

    const handleLogin = async () => {
      if (isLoading.value) return
      
      errorMessage.value = ''
      isLoading.value = true

      try {
        await authStore.login(form.value)
        // ログイン前にアクセスしようとしたページがあればそこへ、なければダッシュボードへ
        const redirect = route.query.redirect || '/dashboard'
        await router.push(redirect)
      } catch (error) {
        console.error('Login error:', error)
        // ローディング状態を確実に解除
        isLoading.value = false
        
        if (error.response?.status === 401) {
          errorMessage.value = 'メールアドレスまたはパスワードが正しくありません'
        } else if (error.response?.data?.detail) {
          errorMessage.value = error.response.data.detail
        } else if (error.message) {
          errorMessage.value = error.message
        } else {
          errorMessage.value = 'ログインに失敗しました。しばらくしてから再度お試しください。'
        }
      }
      // finallyブロックを削除してcatchで確実に処理
    }

    return {
      form,
      errorMessage,
      isLoading,
      isSessionExpired,
      handleLogin
    }
  }
}
</script>